/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ChipsSelectField.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Collapse, IconButton, Typography, Divider } from "@mui/material";
import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import AddIcon from "@mui/icons-material/Add";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import CustomSelectV3 from "./CustomSelectV3";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomButtonV2 from "../button/CustomButtonV2";
function ChipsSelectField({
  size = "small",
  label,
  placeholder,
  required = false,
  disabled = false,

  selectedValue,
  setSelectedValue,

  optionsList = [],

  listValues = [],
  setListValues,
  isAttachDetach,
  handleAttach,
  handleDetach,

  title = "Selected Items",
}) {
  const [openList, setOpenList] = useState(false);

  const selectedOption = useMemo(() => {
    return optionsList.find((o) => o.value === selectedValue);
  }, [selectedValue, optionsList]);

  const addSelectedToList = () => {
    if (!selectedOption) return;

    const alreadyExists = listValues.some(
      (item) => item.value === selectedOption.value,
    );

    if (!alreadyExists) {
      setListValues((prev) => [...prev, selectedOption]);
    }

    setSelectedValue("");
  };

  const canAdd = useMemo(() => {
    if (!selectedOption) return false;
    const alreadyExists = listValues.some(
      (item) => item.value === selectedOption.value,
    );
    return !alreadyExists;
  }, [selectedOption, listValues]);

  const removeItem = (value) => {
    setListValues((prev) => prev.filter((item) => item.value !== value));
  };

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
        <Box sx={{ flex: 1 }}>
          <CustomSelectV3
            size={size}
            label={label}
            placeholder={placeholder}
            required={required}
            selectedValue={selectedValue}
            handleOnChange={(e) => setSelectedValue(e.target.value)}
            optionsList={optionsList}
            disabled={disabled}
          />
        </Box>

        {isAttachDetach ? (
          <Box sx={{ mt: 4 }}>
            <CustomButtonV2
              type="submit"
              disabled={!canAdd || disabled}
              btnName="Attach"
              handleOnClick={() => handleAttach(selectedValue)}
            />
          </Box>
        ) : (
          <IconButton
            onClick={addSelectedToList}
            disabled={!canAdd || disabled}
            sx={{
              backgroundColor: canAdd ? "#26890D" : "#E0E0E0",
              color: canAdd ? "white" : "#9E9E9E",
              borderRadius: 0,
              width: 24,
              height: 24,
              mt: 4,
              "&:hover": {
                backgroundColor: canAdd ? "#1e6b0a" : "#E0E0E0",
              },
            }}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ mt: 1 }}>
        {console.log("listValueslistValues", listValues)}
        {console.log(
          "OptionlistoptionbList",
          optionsList?.filter((data) =>
            listValues?.some((item) => item?.value === data?.value),
          ),
        )}

        <Typography sx={{ fontWeight: 500, textAlign: "center" }}>
          List of Policies
        </Typography>
        <Box
          sx={{
            minHeight: "30vh",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              maxHeight: "30vh",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#b0b0b0",
                borderRadius: "8px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#888",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: "8px",
              },
            }}
          >
            {listValues?.length > 0 ? (
              listValues?.map((data) => (
                <Box
                  key={data?.value || data?.label}
                  sx={{
                    backgroundColor: "#f4f4f4",
                    px: 1,
                    py: 1,
                    mt: 1,
                    borderRadius: 1,
                    fontSize: "0.85rem",
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 400 }}>
                        {" "}
                        {data?.label}
                      </Typography>
                      <Box>
                       {data?.actions?.length>0&& <Box
                          sx={{
                            display: "flex",
                            cursor: "pointer",
                            alignItems: "center",
                            ml: 0.5,
                          }}
                          onClick={() => setOpenList((prev) => !prev)}
                        >
                          <Typography fontSize="12px" fontWeight={600}>
                            Action Allowed
                          </Typography>

                          {openList ? (
                            <ExpandLess fontSize="small" />
                          ) : (
                            <ExpandMore fontSize="small" />
                          )}
                        </Box>}
                        <Collapse
                          in={openList}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "repeat(3, 1fr)",
                              gap: 1,
                              mt: 1,
                            }}
                          >
                            <Box
                              component="pre"
                              sx={{
                                backgroundColor: "#f4f4f4",
                                borderRadius: 1,
                                fontSize: "0.85rem",
                                fontFamily: "monospace",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowX: "auto",
                                maxHeight: 100,
                              }}
                            >
                              {data?.actions?.map((item, idx) => (
                                <div key={item || idx}>
                                  {idx + 1}. {item}
                                </div>
                              ))}
                            </Box>
                          </Box>
                        </Collapse>
                      </Box>
                    </Box>
                    <Box>
                      {isAttachDetach ? (
                        <Box>
                          <CustomButtonV2
                            type="submit"
                            btnName="Detach"
                            handleOnClick={() => handleDetach(data?.value)}
                          />
                        </Box>
                      ) : (
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            removeItem(data?.value);
                          }}
                        >
                          <DeleteIcon sx={{ color: "black" }} />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography sx={{ fontWeight: 200, textAlign: "center" }}>
                No Policies Found
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

ChipsSelectField.propTypes = {
  size: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  selectedValue: PropTypes.any,
  setSelectedValue: PropTypes.func,
  optionsList: PropTypes.array,
  listValues: PropTypes.array,
  setListValues: PropTypes.func,
  isAttachDetach: PropTypes.bool,
  handleAttach: PropTypes.func,
  handleDetach: PropTypes.func,
  title: PropTypes.string,
};

ChipsSelectField.defaultProps = {
  size: "small",
  label: "",
  placeholder: "",
  required: false,
  disabled: false,
  selectedValue: "",
  setSelectedValue: () => {},
  optionsList: [],
  listValues: [],
  setListValues: () => {},
  isAttachDetach: false,
  handleAttach: () => {},
  handleDetach: () => {},
  title: "Selected Items",
};

export default ChipsSelectField;
